/* eslint-disable vue/no-bare-strings-in-template,
@intlify/vue-i18n/no-raw-text, prettier/prettier */
<script>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, prettier/prettier */
export default {
  name: 'WhatsappGroupsLayout',
  data() {
    return {
      moreOpen: false,
    };
  },
  computed: {
    accountId() {
      return this.$route.params.accountId;
    },
    basePath() {
      return '/app/accounts/' + this.accountId + '/whatsapp-groups';
    },
    primaryTabs() {
      return [
        {
          key: 'dashboard',
          label: 'Visão geral',
          icon: 'i-ri-dashboard-line',
          to: this.basePath + '/overview',
          exact: true,
        },
        {
          key: 'campaigns',
          label: 'Campanhas',
          icon: 'i-ri-megaphone-line',
          to: this.basePath + '/campaigns',
          exact: false,
        },
        {
          key: 'groups',
          label: 'Grupos',
          icon: 'i-ri-group-line',
          to: this.basePath + '/groups',
          exact: false,
        },
      ];
    },
    moreSections() {
      return [
        {
          key: 'history',
          items: [
            {
              key: 'messages',
              label: 'Histórico de disparos',
              icon: 'i-ri-history-line',
              to: this.basePath + '/messages',
            },
          ],
        },
        {
          key: 'rest',
          items: [
            {
              key: 'sequences',
              label: 'Sequências',
              description: 'Automações por membro após entrar no grupo',
              icon: 'i-ri-list-ordered',
              to: this.basePath + '/sequences',
              advanced: true,
            },
            {
              key: 'adhoc',
              label: 'Disparo avulso',
              icon: 'i-ri-send-plane-line',
              to: this.basePath + '/messages?adhoc=1',
              advanced: true,
            },
            {
              key: 'webhooks',
              label: 'Webhooks',
              icon: 'i-ri-webhook-line',
              to: this.basePath + '/webhooks',
            },
            {
              key: 'activities',
              label: 'Atividades',
              icon: 'i-ri-pulse-line',
              to: this.basePath + '/activities',
            },
          ],
        },
      ];
    },
    moreTabsFlat() {
      return this.moreSections.flatMap(section => section.items);
    },
    moreActive() {
      return this.moreTabsFlat.some(tab => this.isActive(tab));
    },
  },
  watch: {
    $route() {
      this.moreOpen = false;
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
  },
  methods: {
    onDocumentKeydown(event) {
      if (!this.moreOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.moreOpen = false;
        this.$nextTick(() => this.$refs.moreButton?.focus());
        return;
      }

      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const items = Array.from(
        this.$refs.moreMenu?.querySelectorAll('[role="menuitem"]') || []
      );
      if (!items.length) return;
      event.preventDefault();
      const current = items.indexOf(document.activeElement);
      let next = 0;
      if (event.key === 'End') next = items.length - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'ArrowUp')
        next = current <= 0 ? items.length - 1 : current - 1;
      else next = current < 0 || current === items.length - 1 ? 0 : current + 1;
      items[next].focus();
    },

    onDocumentClick(event) {
      if (!this.moreOpen) return;
      const root = this.$refs.moreMenu;
      if (root && !root.contains(event.target)) {
        this.moreOpen = false;
      }
    },

    toggleMore(event) {
      event.stopPropagation();
      this.moreOpen = !this.moreOpen;
      if (this.moreOpen) {
        this.$nextTick(() =>
          this.$refs.moreMenu?.querySelector('[role="menuitem"]')?.focus()
        );
      }
    },

    isActive(tab) {
      const name = this.$route.name;
      if (tab.key === 'dashboard') {
        return name === 'whatsapp_groups_dashboard';
      }
      if (tab.key === 'groups') {
        return (
          name === 'whatsapp_groups_list' || name === 'whatsapp_group_detail'
        );
      }
      if (tab.key === 'messages' || tab.key === 'adhoc') {
        return name === 'whatsapp_groups_messages';
      }
      if (tab.key === 'sequences') {
        return name === 'whatsapp_groups_sequences';
      }
      if (tab.key === 'campaigns') {
        return (
          name === 'whatsapp_groups_campaigns' ||
          name === 'whatsapp_groups_campaign_detail'
        );
      }
      if (tab.key === 'webhooks') {
        return name === 'whatsapp_groups_webhooks';
      }
      if (tab.key === 'activities') {
        return name === 'whatsapp_groups_activities';
      }
      return false;
    },
  },
};
</script>

<template>
  <!-- overflow só no main: overflow na section/nav clipava o dropdown do Mais -->
  <section class="flex flex-col w-full h-full bg-n-background">
    <header class="sticky top-0 z-30 px-6 border-b border-n-weak bg-n-solid-1">
      <div class="w-full max-w-6xl mx-auto">
        <div class="flex items-center h-[4.5rem] gap-2">
          <div>
            <span
              class="text-[1.25rem] font-bold tracking-tight text-n-slate-12"
            >
              Grupos WhatsApp
            </span>
            <p class="text-[13px] text-n-slate-11 mt-0.5">
              Campanhas e salas — Jornada e sequência no wizard de campanha
            </p>
          </div>
        </div>
        <nav class="flex items-center gap-1 -mb-px">
          <router-link
            v-for="tab in primaryTabs"
            :key="tab.key"
            :to="tab.to"
            :exact="tab.exact"
            class="inline-flex items-center gap-1.5 px-3 py-2.5 text-[13px] font-medium border-b-2 transition-colors whitespace-nowrap"
            :class="
              isActive(tab)
                ? 'border-n-brand text-n-brand'
                : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
            "
          >
            <span class="block size-4 flex-shrink-0" :class="[tab.icon]" />
            {{ tab.label }}
          </router-link>

          <div ref="moreMenu" class="relative z-40">
            <button
              ref="moreButton"
              type="button"
              class="inline-flex items-center gap-1.5 px-3 py-2.5 text-[13px] font-medium border-b-2 transition-colors whitespace-nowrap"
              :class="
                moreActive || moreOpen
                  ? 'border-n-brand text-n-brand'
                  : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
              "
              :aria-expanded="moreOpen ? 'true' : 'false'"
              aria-haspopup="menu"
              @click="toggleMore"
            >
              <span class="i-ri-more-line block size-4 flex-shrink-0" />
              Mais
              <span
                class="block size-3.5"
                :class="
                  moreOpen ? 'i-ri-arrow-up-s-line' : 'i-ri-arrow-down-s-line'
                "
              />
            </button>
            <div
              v-if="moreOpen"
              role="menu"
              class="absolute left-0 top-full z-50 mt-1 min-w-64 rounded-[10px] border border-n-weak bg-n-solid-1 shadow-lg py-1"
            >
              <template
                v-for="(section, sIdx) in moreSections"
                :key="section.key"
              >
                <div v-if="sIdx > 0" class="my-1 border-t border-n-weak" />
                <p
                  v-if="section.label"
                  class="px-3 pt-1.5 pb-1 text-[11px] font-semibold uppercase tracking-wide text-n-slate-10"
                >
                  {{ section.label }}
                </p>
                <router-link
                  v-for="tab in section.items"
                  :key="tab.key"
                  :to="tab.to"
                  role="menuitem"
                  class="flex items-start gap-2 px-3 py-2 text-sm text-n-slate-12 hover:bg-n-alpha-2"
                  :class="isActive(tab) ? 'bg-n-alpha-2 font-medium' : ''"
                  @click="moreOpen = false"
                >
                  <span
                    class="block size-4 flex-shrink-0 text-n-slate-11 mt-0.5"
                    :class="[tab.icon]"
                  />
                  <span class="flex-1 min-w-0">
                    <span class="flex items-center gap-2">
                      <span>{{ tab.label }}</span>
                      <span
                        v-if="tab.advanced"
                        class="text-[10px] uppercase tracking-wide text-n-slate-10"
                      >
                        avançado
                      </span>
                    </span>
                    <span
                      v-if="tab.description"
                      class="block text-[11px] font-normal text-n-slate-10 mt-0.5 leading-snug"
                    >
                      {{ tab.description }}
                    </span>
                  </span>
                </router-link>
              </template>
            </div>
          </div>
        </nav>
      </div>
    </header>
    <main class="flex-1 min-h-0 overflow-y-auto">
      <router-view />
    </main>
  </section>
</template>
